module.exports = __webpack_public_path__ + "static/media/flying-red.addf2e6c.jpg";